import React, { useEffect } from 'react';
import Loader from 'react-loaders';
import { ModalBody, Button } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';

interface DocSuccessProps {
    type: 'nda' | 'agreement';
}

const DocSuccess = (props: DocSuccessProps) => {
    useEffect(() => {
        setNdaSignedSuccess();
    }, []);

    const setNdaSignedSuccess = () => {
        window.top.postMessage('true', '*');
    };

    const header = props.type == 'nda' ? 'Making Progress' : 'Confirming Document Execution!';
    const text =
        props.type == 'nda'
            ? 'Thank you for executing the Referral Partner NDA'
            : "Thank you for executing the document. We are awaiting Sign Request's confirmation of the successfully executed document. This should only take a minute or so. We appreciate your patience.";

    return (
        <Rodal
            visible={true}
            showMask={false}
            width="400"
            showCloseButton={false}>
            <ModalBody height="425px">
                <div
                    className="text-center"
                    style={{
                        marginTop: '30px',
                        marginLeft: '50%',
                        height: '50px',
                    }}>
                    <Loader type="ball-scale-multiple" active />
                </div>
                <h3 className="text-center">{header}</h3>
                <span className="text-center">{text}</span>
                <div className="text-center" style={{ marginTop: '10px' }}>
                    <Button
                        type="button"
                        color="success"
                        onClick={setNdaSignedSuccess}>
                        Refresh
                    </Button>
                </div>
            </ModalBody>
        </Rodal>
    );
};
export default DocSuccess;
